import { Component, ChangeDetectionStrategy , inject} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Activo } from '@/app/models/Activos';
import { ActivosService } from '@/app/services/activos.service';
import { EstacionesService } from '@/app/services/estaciones.service';
import { TokenReaderService } from '@/app/services/security/token-reader.service';
import { CrearActivoComponent } from '@/app/components/activos/crear-activo/crear-activo.component';
import { EditarActivoComponent } from '@/app/components/activos/editar-activo/editar-activo.component';
import { CuentaCreditoComponent } from '@/app/components/configuraciones/cuenta-credito/cuenta-credito.component';

@Component({
    selector: 'app-lista-activos',
    templateUrl: './lista-activos.component.html',
    styleUrls: ['./lista-activos.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ListaActivosComponent {
  private spinner = inject(NgxSpinnerService);

  busquedaRQ = {
    estacion: '',
    numActivo: '',
  }

  //validaciones
    isAdmin: boolean = true;

  //Lista de usuarios
  lista: Activo[] = [];

  //catalogos
  estaciones: any[] = [];
  constructor(
    private activosService: ActivosService,
    private toastr: ToastrService, 
    private router: Router,
    private dialog: MatDialog,
    private estacionesService: EstacionesService,
    private userTokenReader: TokenReaderService,
  ){

    if(this.userTokenReader.getUserData().estacion != null && this.userTokenReader.getUserData().estacion != ''){
      this.busquedaRQ.estacion = this.userTokenReader.getUserData().estacion;
    }
    //this.isAdmin = this.userTokenReader.isAdmin();

    this.obtenerEstaciones();
    this.getEquipos();
  }


  obtenerEstaciones() {
    this.spinner.show();

    this.estacionesService.obtenerEstaciones().subscribe({
      next: (data: any) => {
        this.estaciones =  data.Estaciones.filter( (i: any) => i['IATA'] !== '').map( (i: any) => {return { label: i.IATA, value: i.IATA } });
      },
      error: (err) => {
        this.spinner.hide();
        if (err.status == 401) {
          this.toastr.error(
            'Tu sesión expiró o no tienes permiso para ver esta página.',
            'Acceso no autorizado'
          );
          this.router.navigate(['/login']);
        } else {
          if (err.error) {
            let { ClassInfo } = err.error;
            this.toastr.error(ClassInfo ? ClassInfo.Error : 'Comprueba tu conexión a internet.' , 'Error');
          }
        }
        console.log(err);
      },
    });
  }

  getEquipos(){
    if(this.busquedaRQ.estacion === null || this.busquedaRQ.estacion === 'null'){
      this.busquedaRQ.estacion = '';
    }

    let busquedaRQModifcado = {
      estacion: this.busquedaRQ.estacion == '' ? null : this.busquedaRQ.estacion,
      numActivo: this.busquedaRQ.numActivo == '' ? null : this.busquedaRQ.numActivo,
    }
    this.spinner.show();
    this.activosService.getEquipos(busquedaRQModifcado).subscribe({
      next: (data: any) => {
        //console.log(data);
        this.lista = data.Activos;
        this.spinner.hide();
      },
      error: (err) => {
        this.spinner.hide();

        if (err.status == 401) {
          this.toastr.error(
            'Tu sesión expiró o no tienes permiso para ver esta página.',
            'Acceso no autorizado'
          );
          this.router.navigate(['/login']);
        } else {
          if (err.error) {
            let { ClassInfo } = err.error;
            this.toastr.error(ClassInfo ? ClassInfo.Error : 'Comprueba tu conexión a internet.' , 'Error');
          }
        }
        console.log(err);
      },
    });
  }

  abrirModalCrearActivo(){
    const dialogRef = this.dialog.open(CrearActivoComponent, {
      width: '800px',
      height: '640px',
      panelClass: 'custom-dialog-container',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result.updateList) this.getEquipos();
    });

    this.router.events.subscribe(() => {
      dialogRef.close();
    });
  }


  abrirModalEditarActivo(activo: Activo){
    const dialogRef = this.dialog.open(EditarActivoComponent, {
      width: '800px',
      height: '640px',
      panelClass: 'custom-dialog-container',
      data: { numActivo: activo.Activo},
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result.updateList) this.getEquipos();
    });

    this.router.events.subscribe(() => {
      dialogRef.close();
    });
  }

  //configuracion
  abrirModalCuentaCredito(){
    const dialogRef = this.dialog.open(CuentaCreditoComponent, {
      width: '420px',
      height: '350px',
      panelClass: 'custom-dialog-container',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result.updateList) this.getEquipos();
    });

    this.router.events.subscribe(() => {
      dialogRef.close();
    });
  }


}
